import { Component, Input, OnInit } from '@angular/core';
import { ProtectionPlanPricingPlan } from '../../../models';
import { PricingPlanService } from 'services';

@Component({
	selector: 'app-protection-plan-pricing-plan',
	template: require('./protection-plan-pricing-plan.component.html'),
	styles: [require('./protection-plan-pricing-plan.component.scss')],
	host: { class: 'flex flex-col flex-1 overflow-hidden mt-10 lg:mt-0' },
})
export class ProtectionPlanPricingPlanComponent implements OnInit {
	@Input() clientId: string;

	protectionPlanPricingPlans: ProtectionPlanPricingPlan[];
	constructor(private pricingPlanService: PricingPlanService) {}

	ngOnInit() {
		this.pricingPlanService.getProtectionPlanPricingPlans(this.clientId).subscribe(r => {
			this.protectionPlanPricingPlans = r;
		});
	}
}
